export * from '@fhs/routing/src/routes/auth/continuewithemail/index';
export { default } from '@fhs/routing/src/routes/auth/continuewithemail/index';
